import { render, staticRenderFns } from "./backlit.vue?vue&type=template&id=88668566&scoped=true"
import script from "./backlit.vue?vue&type=script&lang=js"
export * from "./backlit.vue?vue&type=script&lang=js"
import style0 from "./backlit.vue?vue&type=style&index=0&id=88668566&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88668566",
  null
  
)

export default component.exports